import React from 'react';
import moment from 'moment';
import styles from './index.module.scss';

const EventDetails = ({ event, entityLanguage, t }) => {
    const { dtStartDate, dtEndDate, address } = event;

    const isNotEnglish = entityLanguage !== "English";
    const formatIsoDate = (isoString: string): string => {
        const date = new Date(isoString);
        return moment(date).format(isNotEnglish ? "DD/MM/YYYY" : "MM/DD/YYYY");
    };

    const formatAddress = (): string => {
        const { street, city, state, zip: postalCode } = address || {};

        return [street, city, state, postalCode]
            .filter(Boolean)
            .join(" ");
    };

    return (
        <div className={`${styles.eventDetails} ${isNotEnglish ? "alignRight" : ""}`}>
            <div className={`${styles.whenSection} ${entityLanguage !== "English" ? "alignRight mr-0 ml-5" : ""}`}>
                <div className={styles.title}>{t("When")}</div>
                <div className={styles.data}>
                    {formatIsoDate(dtStartDate)} - {formatIsoDate(dtEndDate)}
                </div>
            </div>

            {event.address.city && (
                <div>
                    <div className={styles.title}>{t("Where")}</div>
                    <div className={styles.data}>
                        {formatAddress()}
                    </div>
                </div>
            )}
        </div>
    );
};

export default EventDetails;